module.exports = __webpack_public_path__ + "img/horizontal_6_4_4.45292e32.png";